export default __webpack_public_path__ + "static/media/halonasoft-picturemark-d.13dd207a.svg";